export function getManager(managerId) {
  return { path: `managers/${managerId}` };
}

export function searchManagers(query) {
  return { path: `managers${query}` };
}

export function createManager(name) {
  return {
    path: 'managers',
    method: 'POST',
    body: JSON.stringify({ name }),
  };
}

export function updateManager(managerId, newName) {
  return {
    body: JSON.stringify({ name: newName }),
    path: `managers/${managerId}`,
    method: 'PUT',
  };
}

export function deleteManager(managerId) {
  return {
    path: `managers/${managerId}`,
    method: 'DELETE',
  };
}

export function getManagerProducts(managerId) {
  return { path: `managers/${managerId}/products` };
}
